import { CloudUpload } from "lucide-react";

import { useBgUploads } from "../lib/backgroundUploads";

/**
 * Что грузится в фоне (09.10.2026): окно ролика закрыли, а файл ещё едет.
 * Плашка внизу — чтобы не закрыли вкладку и знали, что сдача уйдёт сама.
 */
export function BackgroundUploads() {
  const entries = useBgUploads((s) => s.entries);
  const active = Object.entries(entries).filter(([, e]) => e.files.some((f) => !f.done));
  if (!active.length) return null;
  return (
    <div className="pointer-events-none fixed bottom-20 left-1/2 z-40 flex -translate-x-1/2 flex-col items-center gap-2 md:bottom-4">
      {active.map(([id, e]) => {
        const total = e.files.reduce((s, f) => s + f.size, 0) || 1;
        const done = e.files.reduce((s, f) => s + f.size * f.progress, 0);
        return (
          <div key={id} className="pointer-events-auto flex max-w-[320px] items-center gap-2.5 rounded-full border bg-background px-4 py-2 text-[13px] shadow-mmd">
            <CloudUpload className="size-4 shrink-0 animate-pulse text-primary" />
            <span className="min-w-0 truncate">«{e.title}»</span>
            <span className="shrink-0 tabular-nums text-muted-foreground">{Math.round((done / total) * 100)}%</span>
            {e.submit && <span className="shrink-0 text-xs text-primary">сдастся сам</span>}
          </div>
        );
      })}
    </div>
  );
}
